import { render, staticRenderFns } from "./trae_compras.vue?vue&type=template&id=de03dab0&"
import script from "./trae_compras.vue?vue&type=script&lang=js&"
export * from "./trae_compras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports